import {
  LayoutButtonsCheckout,
  LayoutPaddinCheckout,
  Timer,
} from "@/Components/Index";
import { useCallback, useEffect, useState } from "react";
import FormStore from "./Store/FormStore";
import FormClient from "./Client/FormClient";
import { useContextTicketProvider } from "@/Context/Ticket/ContextTicketCartProvider";
import {
  getIpCliente,
  useCheckoutAddOrderBuyV2,
  useCheckoutCart,
  useDeleteOrderBuy,
} from "@/Service/Api/Index";
import type { MBuyCarCheckout } from "@/Models/MBuyCarCheckout/MBuyCarCheckout";
import type { MBuyFrom } from "@/Models/MBuyFrom/MBuyFrom";
import type { BuyProduct } from "@/Models/MBuyPropduct/BuyProduct";
import { useTicketCart } from "@/Hooks/TicketCart/useTicketCart";
import { useNavigate } from "react-router-dom";
import { useContextHeaderData } from "@/Context/Header/ContextHeaderProvider";
import { useContextCheckoutData } from "@/Context/Checkout/ContextCheckoutProvider";

const FormClientStore = () => {
  const { saveHeaderTicket } = useContextHeaderData();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { addTicketProduct, DeleteClearCart } = useTicketCart();
  //
  const { MDatos: responseData, isLoadingCheckout: isLoadingReFresh } =
    useCheckoutAddOrderBuyV2(false, addTicketProduct);
  const { SaveResponseBasket, SaveDataClient, SaveMBasketMFormData } =
    useContextTicketProvider();
  //
  const {
    PaymentMehted, //, SaveCodeBarra
  } = useContextTicketProvider();
  const { postData, checkoutBuySku } = useCheckoutCart();
  //
  const { DeleteTaskClearContext } = useContextCheckoutData();
  const { deleteData, eliminarOrderBuySku } = useDeleteOrderBuy(
    addTicketProduct[0]?.item_id ?? ""
  );
  const { ResponseBasket, ClearDeleteTicket } = useContextTicketProvider();
  const [loginDelete, setLoginDelete] = useState<boolean>(false);
  //
  const [ViewForm, setViewForm] = useState<boolean>(true);
  const [visivility, setVisivility] = useState<boolean>(false);
  const [PrintTitle, setPrintTitle] = useState<string>("");
  const navigate = useNavigate();

  const handleClick = (view: boolean) => {
    const typePayment = view ? "Recoger en tienda" : "Envío a domicilio";
    PaymentMehted(typePayment);
    setPrintTitle("");
    setVisivility(true);
    setViewForm(view);
    setPrintTitle(typePayment);
  };

  const CreateParchaseOrder = async (formDatas: MBuyCarCheckout) => {
    //Verificamos que no venga null o vacio
    if (!addTicketProduct || addTicketProduct.length === 0) return;

    setIsLoading(true);

    const dataPdp: BuyProduct = {
      skuId:
        addTicketProduct
          .flatMap((x) => x.item_id)
          .filter(Boolean)
          .join(",") ?? "",
      productItems: addTicketProduct,
    };

    const MBasket_MFormData: MBuyFrom = {
      dataPdp: dataPdp,
      formData: formDatas,
    };

    SaveMBasketMFormData(MBasket_MFormData);
    SaveDataClient(formDatas);

    //mandamos a llamar el endpoint
    await postData(checkoutBuySku, MBasket_MFormData).finally(() => {
      setIsLoading(false);
    });

    if (!isLoading) {
      saveHeaderTicket(true);
      navigate(
        `/Electrónicav2/articles/c/Checkout/ticketPrint?viewCart=printticket.html`
      );
    }
  };

  const clickDelete = useCallback(async () => {
    //console.log("Eliminar el basket id del carrito");
    const ipClient = await getIpCliente();
    const deleteBuyOrder = {
      basketId: ResponseBasket?.basketId,
      skuId:
        addTicketProduct
          .flatMap((x) => x.item_id)
          .filter(Boolean)
          .join(",") ?? "",
      ipAddress: ipClient,
    };
    DeleteClearCart();
    DeleteTaskClearContext();
    ClearDeleteTicket();
    setLoginDelete(true);
    //ENVIAMOS HACIA EL BACK PARA ELIMINAR DESDE CACHE Y LIMPIAR LO DATOS GUARDADOS
    await deleteData(eliminarOrderBuySku, deleteBuyOrder).finally(() => {
      setLoginDelete(false);
    });
    saveHeaderTicket(false);
    //SE RETORNA HACIA EL INICIO DE LA VERSIÓN V2
    if (!loginDelete) {
      navigate(`/Electrónicav2`);
    }
  }, []);

  useEffect(() => {
    if (!isLoadingReFresh) SaveResponseBasket(responseData);
  }, [isLoadingReFresh]);

  return (
    <div className="row">
      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <div className="ps-form__billing-info">
          {/* <h3 className="ps-form__heading">Detalle de facturación</h3> */}
          <Timer inicilizarTimer={120000} clickDelete={clickDelete} />
          <LayoutButtonsCheckout>
            <LayoutPaddinCheckout>
              <button
                className={
                  !ViewForm
                    ? "develop__buttons develop___btnsoriana-pick-up develop__disabled"
                    : "develop__buttons develop___btnsoriana-pick-up develop__invabled"
                }
                onClick={() => handleClick(true)}>
                <div className="main-text">
                  <span className="text-red">Pick {""}</span>
                  <span className="text-green">{""} up</span>
                </div>
                <div className="main-text main-text-com">
                  <span className="small-text">
                    {" "}
                    soriana {""}
                    {""}
                  </span>
                  <span className="small-text-com">{""} .com</span>
                </div>
              </button>
            </LayoutPaddinCheckout>
            <LayoutPaddinCheckout>
              <button
                className={
                  ViewForm
                    ? "develop__buttons develop___btnsoriana-domicilio develop__disabled"
                    : "develop__buttons develop___btnsoriana-domicilio develop__invabled"
                }
                onClick={() => handleClick(false)}>
                <div className="main-text">
                  <i className="fa-sharp fa-solid fa-truck truck-icon"></i>
                  <div className="d-flex flex-column">
                    <span className="text-green">Envío a</span>
                    <span className="text-red-bg">domicilio</span>
                  </div>
                </div>
              </button>
            </LayoutPaddinCheckout>
          </LayoutButtonsCheckout>
          <div
            className="text_Center___develop"
            style={{ marginTop: "20px", marginBottom: "20px" }}>
            <div className="develop___text__checkout">
              <span>
                {PrintTitle == "Recoger en tienda"
                  ? PrintTitle + ":"
                  : PrintTitle}
              </span>
            </div>
            <div style={{ marginTop: "-8px" }}>
              <span className="develop___text__checkout_one">
                {PrintTitle == "Recoger en tienda"
                  ? "Soriana Híper San Pedro"
                  : ""}
              </span>
              <div style={{ marginTop: "-5px" }}>
                <span>
                  {PrintTitle == "Recoger en tienda"
                    ? "(en 5 días hábiles)"
                    : ""}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* vista de los formularios si es retiro en tienda o domicilio*/}
      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        {visivility ? (
          ViewForm ? (
            <div className="d-flex justify-content-center">
              {/* Formulario de retiro en tienda */}
              <FormStore
                createParchaseOrder={CreateParchaseOrder}
                isLoading={isLoading}
              />
            </div>
          ) : (
            <div className="">
              {/* Formulario de envío a domicilio */}
              <FormClient
                createParchaseOrder={CreateParchaseOrder}
                isLoading={isLoading}
              />
            </div>
          )
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default FormClientStore;
